import { defineMessage, MessageDescriptor } from 'react-intl';
import { RecommendationsActivityType, StatsResponse } from 'src/api/me/types';

export type DisplayedActivity = {
  type: RecommendationsActivityType;
  statsField: keyof StatsResponse;
  labelMessage: MessageDescriptor;
};

export const DISPLAYED_ACTIVITIES: DisplayedActivity[] = [
  {
    type: 'learn',
    statsField: 'wordsLearned',
    labelMessage: defineMessage({ id: 'myActivities_wordsLearned_label' }),
  },
  {
    type: 'learn',
    statsField: 'wordsReviewed',
    labelMessage: defineMessage({ id: 'myActivities_wordsReviewed_label' }),
  },
  {
    type: 'immerse',
    statsField: 'wordsHeard',
    labelMessage: defineMessage({ id: 'myActivities_wordsHeard_label' }),
  },
  {
    type: 'immerse',
    statsField: 'videosWatched',
    labelMessage: defineMessage({ id: 'myActivities_videosWatched_label' }),
  },
  {
    type: 'immerse',
    statsField: 'videosUnderstood',
    labelMessage: defineMessage({ id: 'myActivities_videosUnderstood_label' }),
  },
  {
    type: 'immerse',
    statsField: 'partlyUnderstood',
    labelMessage: defineMessage({ id: 'myActivities_partlyUnderstood_label' }),
  },
  {
    type: 'communicate',
    statsField: 'membotChats',
    labelMessage: defineMessage({ id: 'myActivities_conversations_label' }),
  },
];
